export default __webpack_public_path__ + "content/media/33.c2d0974a.jpg";